import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import { getConfig } from "../../utils/config";

const config = getConfig();

const colors = config.theme.colors;
const fontFamily = config.theme.font.family;

const BaseTextStyle = `
    font-family: ${fontFamily};
    font-weight: bold;
    letter-spacing: ${config.theme.text.letterSpacing};
    color: ${colors.dark};
    margin: 0px;
    margin-bottom: 2px;
    padding: 0px;

    @media(max-width: 700px){
      font-size: .9em
    }
`;

const Paragraph = styled.p`
  ${BaseTextStyle}
  ${(props) => {
    let styles = "";
    if (props.color) {
      styles += `color: ${colors[props.color || 'primary']};`;
    }else{
      styles += `color: ${colors.primary};`;
    }
    if (props.align) {
      styles += `text-align: ${props.align};`;
    }
    if (props.fontSize) {
      if (props.fontSize === "sm") {
        styles += `font-size: .9em`;
      } else if (props.fontSize === "md") {
        styles += `font-size: 1.6em`;
      } else if (props.fontSize === "lg") {
        styles += `font-size: 2em`;
      } else if (props.fontSize === "xlg") {
        styles += `font-size: 2.6em`;
      } else {
        styles += `font-size: ${props.fontSize};`;
      }
    }
    if (props.py) {
      styles += `paddin-top: ${props.py}em;`;
      styles += `paddin-bottom: ${props.py}em;`;
    }

    return css`
      ${styles}
    `;
  }}
`;

/**
 * Render a Text
 */

const Text = (props) => <Paragraph {...props}>{props.children}</Paragraph>;

export default Text;

Text.propTypes = {
  /**
   * Default Color Scheme
   */
  color: PropTypes.oneOf(["primary", "sencondary", "white", "danger"]),
  /**
   * Inner Child
   */
  children: PropTypes.node,
  /**
   * Text Align
   */
  align: PropTypes.oneOf(["center", "left", "rigth", "justify"]),
  /**
   * Text Font size, use a literal setting ex: 12px, 2em or sm('small'): .9em, md('medium'): 1.6em, lg('large'): 2em, xlg('extra large'): 2.6em
   */
  fontSize: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/_components/Text/index.jsx